import { Layout, Menu, Breadcrumb, Row, Col } from 'antd'

import {
  AppstoreOutlined,
  CodeOutlined,
  ProfileOutlined,
  CodeSandboxOutlined,
  DeploymentUnitOutlined,
  DesktopOutlined,
  ExperimentOutlined,
  FileDoneOutlined,
  FilePptOutlined,
  MenuOutlined,
  GoldOutlined,
  BankOutlined,
  VideoCameraOutlined,
  ProjectOutlined,
  CalculatorOutlined,
  SolutionOutlined,
  UserOutlined,
  EditOutlined,
  PhoneOutlined,
  AudioOutlined,
  UserSwitchOutlined,
  OrderedListOutlined,
  TagsOutlined,
} from '@ant-design/icons'
import { useState } from 'react'
import React from 'react'
import oamStyles from './oam-sider.module.less'
import SubMenu from 'antd/lib/menu/SubMenu'

const { Header, Content, Sider } = Layout
import logoSvg from '../../static/image/logo-icon.svg'
//import TeacherAuthenticate from '../../component/modal/teacher-authenticate/teacher-authenticate';

export interface Props {
  keys: any
  openKeys: any //默认打开的子目录
}

export const OAMSider: React.FC<Props> = (props: Props) => {
  const { keys, openKeys } = props
  const [collapsed, setCollapsed] = useState(false)
  const [selectedKey, setSelectedKey] = useState('2')

  const handleClick = (e: any) => {
    setSelectedKey(e.key)
    if (e.key == '1') {
      window.location.href = '/oam_user_list'
    } else if (e.key == '11') {
      window.location.href = '/oam_user_stat'
    } else if (e.key == '12') {
      window.location.href = '/oam_user_list'
    } else if (e.key == '13') {
      window.location.href = '/oam_user_apply'
    } else if (e.key == '14') {
      window.location.href = '/oam_teacher_apply'
    } else if (e.key == '15') {
      window.location.href = '/oam_college_code_apply'
    } else if (e.key == 'user_analysis') {
      window.location.href = '/oam_user_analysis'
    } else if (e.key == '2') {
      //项目
      window.location.href = '/oam_project'
    } else if (e.key == 'payment_order') {
      //购买订单
      window.location.href = '/oam_purchase_list'
    } else if (e.key == '88') {
      //分类标签
      window.location.href = '/oam_category_list'
    }else if (e.key == '3') {
      //大纲
      window.location.href = '/oam_menu'
    }  else if (e.key == '21') {
      //镜像
      window.location.href = '/oam_image'
    }else if (e.key == '4') {
      //章节
      window.location.href = '/oam_chapter'
    } else if (e.key == '5') {
      //任务
      window.location.href = '/oam_task'
    } else if (e.key == '6') {
      //习题
      window.location.href = '/oam_exercise'
    } else if (e.key == '7') {
      //视频
      window.location.href = '/oam_video'
    } else if (e.key == '8') {
      //教室
      window.location.href = '/oam_classroom'
    } else if (e.key == '9') {
      //机构
      window.location.href = '/oam_institution_list'
    } else if (e.key == '10') {
      //报告节点
      window.location.href = '/oam_report_node'
    } else if (e.key == '101') {
      //报告
      window.location.href = '/oam_report'
    } else if (e.key == 'logo—manager') {
      // logo 管理
      window.location.href = '/oam_logo_manager'
    } else if (e.key == 'cluster_manager') {
      //集群监控
      window.location.href = '/oam_cluster_manager'
    } else if (e.key == 'commit_record') {
      //提交记录
      window.location.href = '/oam_commit_record'
    } else if (e.key == 'dataset') {
      //提交记录
      window.location.href = '/oam_dataset_list'
    } else {
      window.location.href = '/oam_user_list'
    }
  }

  const onCollapse = (collapsed: boolean) => {
    setCollapsed(collapsed)
  }

  const handleMainPage = () => {
    window.location.href = '/'
  }

  return (
    <Sider width={200} style={{ backgroundColor: '#1e1b4b' }}>
      {/* <TeacherAuthenticate></TeacherAuthenticate> */}
      <Row
        onClick={handleMainPage}
        align="middle"
        gutter={[8, 8]}
        style={{
          cursor: 'pointer',
          margin: 0,
          height: 60,
          paddingLeft: 15,
          paddingTop: 5,
          borderBottom: '0px solid rgb(24, 43, 43)',
        }}
      >
        <Col>
          <img
            height={32}
            width={32}
            src={logoSvg}
            className={oamStyles.oam_logo}
          ></img>
        </Col>
        <Col style={{ color: '#f2f2f2', fontSize: 20 }}>OAM管理系统</Col>
      </Row>

      <div className={oamStyles.oamMenuWrapper}>
        <Menu
          style={{ marginTop: 20 }}
          theme="dark"
          defaultOpenKeys={openKeys}
          defaultSelectedKeys={keys}
          mode="inline"
          onClick={handleClick}
        >
          <SubMenu key="sub-user" title="用户管理">
            <Menu.Item key="11" icon={<SolutionOutlined />}>
              用户统计
            </Menu.Item>
            <Menu.Item key="12" icon={<UserOutlined />}>
              用户管理
            </Menu.Item>
            <Menu.Item key="user_analysis" icon={<UserSwitchOutlined />}>
              用户分析
            </Menu.Item>
            {/* <Menu.Item key="13" icon={<PhoneOutlined />}>申请信息</Menu.Item> */}
            {/* <Menu.Item key="14" icon={<UserSwitchOutlined />}>
              教师申请
            </Menu.Item> */}

          </SubMenu>
          
          <SubMenu key="sub-institution" title="机构管理">
            <Menu.Item key="9" icon={<BankOutlined />}>
              机构管理
            </Menu.Item>
            <Menu.Item key="15" icon={<OrderedListOutlined />}>
              院校码申请
            </Menu.Item>
          </SubMenu>
  
          <SubMenu key="sub-project" title="项目管理">
            <Menu.Item key="2" icon={<ProjectOutlined />}>
              项目
            </Menu.Item>

            <Menu.Item key="payment_order" icon={<OrderedListOutlined />}>
              购买列表
            </Menu.Item>

            <Menu.Item key="3" icon={<ProfileOutlined />}>
              大纲
            </Menu.Item>

            <Menu.Item key="21" icon={<CodeSandboxOutlined />}>
              镜像
            </Menu.Item>

            <Menu.Item key="4" icon={<AppstoreOutlined />}>
              章节
            </Menu.Item>

            <Menu.Item key="8" icon={<BankOutlined />}>
              班级
            </Menu.Item>

            <Menu.Item key="88" icon={<TagsOutlined  />}>
              分类标签
            </Menu.Item>

          </SubMenu>
          <Menu.Item
            key="dataset"
            icon={<i className="iconfont icon-datafull"></i>}
          >
            数据集
          </Menu.Item>
          <Menu.Item key="5" icon={<CodeOutlined />}>
            任务
          </Menu.Item>

          <Menu.Item key="6" icon={<EditOutlined />}>
            检测习题
          </Menu.Item>

          <SubMenu key="sub-report" title="报告管理">
            <Menu.Item key="101" icon={<GoldOutlined />}>
              报告模板
            </Menu.Item>

            <Menu.Item key="10" icon={<GoldOutlined />}>
              节点
            </Menu.Item>
          </SubMenu>

          {/*<Menu.Item key="7" icon={<VideoCameraOutlined />}>
            视频
          </Menu.Item> */}
          <Menu.Item
            key="logo—manager"
            icon={<i className="iconfont icon-shezhi"></i>}
          >
            logo配置
          </Menu.Item>

          {/* <Menu.Item key="cluster_manager" icon={<i className='iconfont icon-supervision'></i>}>
              集群监控
            </Menu.Item>

            <Menu.Item key="commit_record" icon={<i className='iconfont icon-wodetijiaojilu'></i>}>
              提交记录
            </Menu.Item> */}
        </Menu>
      </div>
    </Sider>
  )
}

export default OAMSider
